import {BlockSelector, ESD_BLOCK_STRUCTURE} from '../../constants/BlockName';
import {ImmutableHtmlNode} from '../../modifications/ImmutableNode';
import {BuiltInControl} from '../BuiltInControl';

export abstract class StructureBuiltInControl extends BuiltInControl {
  public getTargetNodes(root: ImmutableHtmlNode): ImmutableHtmlNode[] | undefined {
    const structures = root.querySelectorAll(BlockSelector.STRUCTURE);
    const structure = root.asElement().hasClass(ESD_BLOCK_STRUCTURE) ? [root] : [];
    return structures.length ? structures : structure;
  };
}
